var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLightModeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.129a3.87 3.87 0 100 7.742 3.87 3.87 0 000-7.742z",
    fill: "#000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 0.774,
    r: 0.774,
    fill: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.161,
    cy: 2.839,
    r: 0.774,
    fill: "#000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.225,
    cy: 8,
    r: 0.774,
    fill: "#000"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.161,
    cy: 13.161,
    r: 0.774,
    fill: "#000"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 15.226,
    r: 0.774,
    fill: "#000"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.839,
    cy: 13.161,
    r: 0.774,
    fill: "#000"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.774,
    cy: 8,
    r: 0.774,
    fill: "#000"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.839,
    cy: 2.839,
    r: 0.774,
    fill: "#000"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuOTk5ODcgNC4xMjg5MUM3LjIzNDI3IDQuMTI4OTEgNi40ODU4NiA0LjM1NTkzIDUuODQ5MjggNC43ODEyOEM1LjIxMjcgNS4yMDY2MyA0LjcxNjU1IDUuODExMTkgNC40MjM1NyA2LjUxODUyQzQuMTMwNTggNy4yMjU4NCA0LjA1MzkzIDguMDA0MTcgNC4yMDMyOSA4Ljc1NTA2QzQuMzUyNjUgOS41MDU5NSA0LjcyMTMyIDEwLjE5NTcgNS4yNjI2OSAxMC43MzcxQzUuODA0MDUgMTEuMjc4NCA2LjQ5Mzc5IDExLjY0NzEgNy4yNDQ2OSAxMS43OTY1QzcuOTk1NTggMTEuOTQ1OCA4Ljc3MzkgMTEuODY5MiA5LjQ4MTIzIDExLjU3NjJDMTAuMTg4NiAxMS4yODMyIDEwLjc5MzEgMTAuNzg3IDExLjIxODUgMTAuMTUwNUMxMS42NDM4IDkuNTEzODkgMTEuODcwOCA4Ljc2NTQ4IDExLjg3MDggNy45OTk4N0MxMS44NzA4IDYuOTczMjMgMTEuNDYzIDUuOTg4NjMgMTAuNzM3MSA1LjI2MjY5QzEwLjAxMTEgNC41MzY3NCA5LjAyNjUyIDQuMTI4OTEgNy45OTk4NyA0LjEyODkxWiIgZmlsbD0iYmxhY2siLz4KPGNpcmNsZSBjeD0iNy45OTk3OCIgY3k9IjAuNzc0MTk0IiByPSIwLjc3NDE5NCIgZmlsbD0iYmxhY2siLz4KPGNpcmNsZSBjeD0iMTMuMTYwOSIgY3k9IjIuODM4NjUiIHI9IjAuNzc0MTk0IiBmaWxsPSJibGFjayIvPgo8Y2lyY2xlIGN4PSIxNS4yMjU0IiBjeT0iNy45OTk3OCIgcj0iMC43NzQxOTQiIGZpbGw9ImJsYWNrIi8+CjxjaXJjbGUgY3g9IjEzLjE2MDkiIGN5PSIxMy4xNjE0IiByPSIwLjc3NDE5NCIgZmlsbD0iYmxhY2siLz4KPGNpcmNsZSBjeD0iNy45OTk3OCIgY3k9IjE1LjIyNTkiIHI9IjAuNzc0MTk0IiBmaWxsPSJibGFjayIvPgo8Y2lyY2xlIGN4PSIyLjgzODY1IiBjeT0iMTMuMTYxNCIgcj0iMC43NzQxOTQiIGZpbGw9ImJsYWNrIi8+CjxjaXJjbGUgY3g9IjAuNzc0MTk0IiBjeT0iNy45OTk3OCIgcj0iMC43NzQxOTQiIGZpbGw9ImJsYWNrIi8+CjxjaXJjbGUgY3g9IjIuODM4NjUiIGN5PSIyLjgzODY1IiByPSIwLjc3NDE5NCIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";
export { SvgLightModeIcon as ReactComponent };